export const ADD_FILTER_DATA = 'ADD_FILTER_DATA';

export function addFilterData(filterData) {
    return { type: ADD_FILTER_DATA, filterData };
}

